import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { advisorAdminApi } from '../api/api';

export function useUpdateAppMode() {
  const mutation = useMutation({
    mutationFn: ({ advisorId, appMode }: { advisorId: string; appMode: AppMode }) =>
      advisorAdminApi.updateAppMode(advisorId, appMode),
    onSuccess: () => {
      toast.success('App mode updated successfully');
    },
  });

  return {
    updateAppMode: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
  };
}
